import loadWishList from "@NA/Handlers/ADILoadWishList";
import loadWishLists from "@NA/Handlers/ADIQuoteRequestWishLists";
import getSubmitRequestQuotenHandler from "@NA/Handlers/ADISubmitRequestQuoteHandler";
import loadWishListLineV2 from "@NA/Handlers/GetWishListLinesV2Handler";
import ADIColors from "@NA/Utils/ADIColors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import { getCurrentAccountState } from "@insite/client-framework/Store/Data/Accounts/AccountsSelector";
import loadCurrentAccount from "@insite/client-framework/Store/Data/Accounts/Handlers/LoadCurrentAccount";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import { BillToModel, WishListLineModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ButtonWrapper } from "@insite/mobius/Button";
import { FormFieldStyle } from "@insite/mobius/FormField";
import { GridContainerProps, GridWrapper } from "@insite/mobius/GridContainer";
import { GridItemProps, GridItemStyle } from "@insite/mobius/GridItem";
import XCircle from "@insite/mobius/Icons/XCircle";
import Plus from "@insite/mobius/Icons/Plus";
import { LazyImagePresentationProps } from "@insite/mobius/LazyImage";
import { LinkPresentationProps } from "@insite/mobius/Link";
import { LoadingOverlayProps } from "@insite/mobius/LoadingOverlay";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import { TextFieldPresentationProps } from "@insite/mobius/TextField";
import { TypographyProps } from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { SelectProps } from "@insite/mobius/Select";
import { getProp } from "@insite/mobius/utilities";
import { FormInputWrapper } from "@insite/mobius/FormField";
import { RQFProductVisibility } from "@NA/Services/RequestQuoteServices";
import {
    Button,
    Clickable,
    FileUpload,
    GridContainer,
    GridItem,
    Icon,
    LazyImage,
    Link,
    LoadingOverlay,
    TextArea,
    TextField,
    Typography,
} from "@insite/mobius/index";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import getColor from "@insite/mobius/utilities/getColor";

import React, { ChangeEvent, FC, useEffect, useState } from "react";
import { ResolveThunks, connect, useDispatch } from "react-redux";
import { css } from "styled-components";
import loadBillToCustom from "@NA/Handlers/ADIGetBillToHandler";
import { GetShipTosApiParameter } from "@insite/client-framework/Services/CustomersService";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { GridOffset } from "@insite/mobius/GridContainer";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { clearCart } from "@insite/client-framework/Services/CartService";
import Select, { SelectPresentationProps } from "@insite/mobius/Select";
import ADIRequestQuoteUploadModal from "@NA/Widgets/MyAccount/ADIRequestQuoteUploadModal";

const mapStateToProps = (state: CustomApplicationState) => {
    const session = state.context.session;
    const adminDCEmail = session.properties.adminDCEmail;
    const account = getCurrentAccountState(state).value;
    const { search, pathname } = getLocation(state);
    const cart = getCurrentCartState(state).value;
    const isAuthenticated = session && session.isAuthenticated;
    const billToParentState = state.ADIGlobalData.ADIBillToStore.billToParentState;
    const billToId = state.components.addressDrawer.selectedBillTo?.id;
    const billtoChildren = state.ADIGlobalData.ADIBillToStore.billToChildState?.billTos;
    const billToState = getBillToState(state, state.context.session.billToId).value;

    return {
        adminDCEmail,
        session,
        account,
        cart,
        search,
        pathname,
        isAuthenticated,
        billToParentState,
        billToId,
        billtoChildren,
        billToState,
    };
};

const mapDispatchToProps = {
    loadCurrentAccount,
    loadWishLists,
    loadWishListLineV2,
    loadWishList,
    getSubmitRequestQuotenHandler,
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;

export interface ADIMyAccountStyles {
    requestQuoteGridContainer?: GridContainerProps;
    contactInformationGridItem?: GridItemProps;
    filesAndProductText: TypographyProps;
    uploadProductListGridItem?: GridItemProps;
    fileuploadStyledWrapper?: InjectableCss;
    fileuploadedStyledWrapper?: InjectableCss;
    uploadStyledWrapper?: InjectableCss;
    dropfileImage?: LazyImagePresentationProps;
    productListHeaderGridContainer?: GridContainerProps;
    productListTextFieldsGridContainer?: GridContainerProps;
    enterProductListGridItem?: GridItemProps;
    addMoreLinkStyledWrapper?: InjectableCss;
    addMoreLink?: LinkPresentationProps;
    noteGridItem?: GridItemProps;
    notesStyledWrapper?: InjectableCss;
    actionGridItem?: GridItemProps;
    contactInformationStyledWrapper?: InjectableCss;
    subHeadings?: TypographyProps;
    headings?: TypographyProps;
    description?: TypographyProps;
    subDescription?: TypographyProps;
    ProductListUL?: TypographyProps;
    subDescriptionOR?: TypographyProps;
    upload?: TypographyProps;
    quantityGridItem?: GridItemProps;
    modelGridItem?: GridItemProps;
    minusIconClickable?: InjectableCss;
    descriptionGridItem?: GridItemProps;
    enterProductListText?: TypographyProps;
    uploadMessage?: TypographyProps;
    inputTextFiled?: TextFieldPresentationProps;
    loadingOverlay?: LoadingOverlayProps;
    spinner?: LoadingSpinnerProps;
    title?: TypographyProps;
    container?: InjectableCss;
    selectStyles?: SelectProps;
    fileuploadedinsidecontainer?: InjectableCss;
    fileuploadedinsidecontainerpaddin?: InjectableCss;
    SubmitButtonWrapper?: InjectableCss;
    mobileScrollView?: TypographyProps;
    typeSelect?: SelectPresentationProps;
    QuoteForm?: InjectableCss;
    onSubmitError?: InjectableCss;
    errorBox?: InjectableCss;
    tooTipParent?: InjectableCss;
    tooTipContent?: InjectableCss;
}

export const adiMyAccountStyles: ADIMyAccountStyles = {
    requestQuoteGridContainer: {
        css: css`
            padding: 26px 23px;
            max-width: 585px !important;
            margin-bottom: 0;
            background-color: ${ADIColors.gray6};
            border-radius: 4px;
            justify-content: center;
            margin: 0;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding: 26px 15px;
                        `,
                    ],
                    "max",
                );
            }}
        `,
    },
    subHeadings: {
        css: css`
            color: ${ADIColors.darkBlue1};
            font-size: 24px;
            line-height: normal;
            margin-top: 0;
            font-weight: bold !important;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            font-size: 20px;
                        `,
                    ],
                    "max",
                );
            }}
        `,
    },
    headings: {
        css: css`
            font-size: 36px;
            font-weight: bold;
            color: ${ADIColors.darkBlue1};
            margin: 0 0 9px 0;
            line-height: 1.17;
            margin: 0;
            padding-bottom: 15px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            font-size: 24px;
                            padding: 0 15px;
                        `,
                    ],
                    "max",
                );
            }}
        `,
    },
    description: {
        css: css`
            margin-top: 20px;
            font-size: 14px !important;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            margin-bottom: 41px;
                            padding: 0px 15px;
                            font-size: 14px;
                            line-height: 1.71;
                            letter-spacing: -0.07px;
                        `,
                    ],
                    "max",
                );
            }}
        `,
    },
    subDescription: {
        css: css`
            color: #2d2926;
            font-size: 14px;
            font-weight: normal;
            line-height: 1.5;
            letter-spacing: -0.08px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            font-size: 14px;
                            margin-bottom: 1.25rem;
                            width: 335px;
                            line-height: 24px;
                        `,
                    ],
                    "max",
                );
            }}
        `,
    },
    ProductListUL: {
        css: css`
            margin: 1em 0 0 2em;
            padding: 0;
            list-style: disc;
        `,
    },
    upload: {
        css: css`
            font-weight: bold !important;
        `,
    },
    subDescriptionOR: {
        css: css`
            color: #2d2926;
            font-size: 14px;
            font-weight: normal;
            line-height: 1.5;
            letter-spacing: -0.08px;
            font-weight: bold !important;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            font-size: 14px;
                            margin-bottom: 1.25rem;
                            width: 335px;
                            line-height: 24px;
                        `,
                    ],
                    "max",
                );
            }}
        `,
    },
    contactInformationGridItem: {
        width: 12,
        css: css`
            display: flex;
            flex-direction: column;
        `,
    },
    contactInformationStyledWrapper: {
        css: css`
            width: 100%;
            display: flex;
            flex-direction: column;
            padding-top: 40px;
            align-items: center;
            gap: 18px;
            > ${FormFieldStyle} {
                max-width: 420px;
                ${FormInputWrapper} {
                    margin-top: 0px !important;
                }
            }
            input {
                height: 38px !important;
                color: #939393 !important;
            }
        `,
    },
    container: {
        css: css`
            width: 100%;
            max-width: 420px;
        `,
    },
    title: {
        css: css`
            font-size: ${getProp("theme.typography.headerTertiary.size")};
            text-transform: capitalize;
            font-weight: 700;
            margin-bottom: 7px;
            display: block;
        `,
    },
    selectStyles: {
        css: css`
            height: 38px !important;
            border: 1px solid ${ADIColors.gray15};
            border-radius: 6px !important;
            font-size: 0.875rem;
            height: 2.7em;
            padding: 0.6em 1.2em 0.6em 0.5em;
            transition: border-color 0.45s ease-in-out 0s;
            box-shadow: none;
            font-family: inherit;
            padding: 9px;
            option {
                font-size: 0.875rem;
            }
        `,
    },
    filesAndProductText: {
        css: css`
            color: ${ADIColors.danger} !important;
            text-align: left !important;
            font-weight: 600 !important;
            letter-spacing: -0.06px;
        `,
    },
    uploadProductListGridItem: {
        width: 12,
        css: css`
            display: flex;
            flex-direction: column;
        `,
    },
    fileuploadStyledWrapper: {
        css: css`
            width: 100%;
            max-height: 100px;
            padding: 0 !important;
            height: 100px;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            border: 1px dashed ${ADIColors.gray10};
            background-color: ${ADIColors.white};
            position: relative;
            max-width: 817px;
            margin: 0 auto;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            max-height: 70px;
                        `,
                    ],
                    "max",
                );
            }}
        `,
    },

    uploadStyledWrapper: {
        css: css`
            display: flex;
            justify-content: center;
            align-items: center;
            ${FormFieldStyle} {
                display: none !important;
            }
            ${ButtonWrapper} {
                background-color: transparent;
                border: none;
                margin: 0;
                padding: 0;
                margin-top: 3px;
                padding-left: 5px;
                > ${TypographyStyle} {
                    margin-left: 5px;
                }
                > span {
                    color: ${getColor("primary")};
                    font-size: 16px;
                    font-weight: 800;
                    margin: 0;
                    padding: 0;
                }
                :hover {
                    background-color: ${ADIColors.white};
                    border: none;
                }
            }
            > ${StyledWrapper} {
                display: flex;
                justify-content: center;
                align-items: center;
            }
        `,
    },
    dropfileImage: {
        css: css`
            width: 50px !important;
            height: auto;
        `,
    },

    fileuploadedStyledWrapper: {
        css: css`
            width: 100%;
            max-height: 100px;
            padding: 0 !important;
            height: 100px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: ${ADIColors.white};
            text-align: center;
            border: 1px dashed ${ADIColors.gray10};
            position: relative;
            max-width: 817px;
            margin: 0 auto;
            font-size: 14px;

            max-height: 100px;
            padding: 0 !important;
            height: 100px;
            display: flex;
            align-items: center;
            justify-content: center;

            ${GridOffset} {
                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                            padding: 0px 10px;
                        `,
                    css``,
                    css`
                            max-height: 100px;
                            padding: 0 !important;
                            height: 100px;
                            display: flex;
                        `,
                    css``,
                    css``,
                ])}
            }
        `,
    },
    fileuploadedinsidecontainer: {
        css: css`
            font-size: 14px;
            line-height: normal;

            width: 33.33%;
            display: inline-block;
            vertical-align: top;
            text-align: left;
            display: flex;
            flex-direction: row !important;
            justify-content: flex-start;
            flex-wrap: nowrap;
            align-items: flex-start;
            padding: 0px 10px;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: block;
                        max-width: 100%;
                        flex-basis: 100%;
                    `,
                    css`
                        display: block;
                        max-width: 100%;
                        flex-basis: 100%;
                    `,
                    css``,
                    css``,
                ])}
        `,
    },
    fileuploadedinsidecontainerpaddin: {
        css: css`
            padding: 0px 10px;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 0px;
                    `,
                    css``,
                    css``,
                    css``,
                    css``,
                ])}
        `,
    },

    productListHeaderGridContainer: {
        css: css`
            margin-top: 10px;
            margin-bottom: -3px;
        `,
    },
    productListTextFieldsGridContainer: {
        css: css`
            margin-bottom: 15px;
            input {
                height: 36px !important;
            }
        `,
    },
    enterProductListGridItem: {
        width: 12,
        css: css`
            display: flex;
            flex-direction: column;
        `,
    },
    enterProductListText: {
        css: css`
            color: ${getColor("text.main")};
            font-weight: 800;
            font-size: 13px;
        `,
    },
    uploadMessage: {
        css: css`
            color: ${getColor("text.main")};
            font-weight: 800;
            font-size: 13px;
            margin-top: 10px;
        `,
    },
    quantityGridItem: {
        width: 2,
        css: css`
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            max-width: 65px;
                            flex-basis: 65px;
                            white-space: nowrap;
                        `,
                    ],
                    "max",
                );
            }}
        `,
    },
    addMoreLinkStyledWrapper: {
        css: css`
            width: 100%;
            display: flex;
            justify-content: end;
            padding-right: 0;
            margin-top: -7px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            justify-content: flex-start;
                        `,
                    ],
                    "max",
                );
            }}
        `,
    },
    addMoreLink: {
        css: css`
            font-size: 14px;
            font-weight: 800;
            line-height: 24px;
            color: ${getColor("primary")};
            margin-right: 20px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            margin-top: 5px;
                        `,
                    ],
                    "max",
                );
            }}
            svg {
                color: ${getColor("primary")};
                position: relative;
                top: 2px;
            }
        `,
    },
    modelGridItem: {
        width: 4,
        css: css`
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            max-width: 140px;
                            flex-basis: 140px;
                        `,
                    ],
                    "max",
                );
            }}
        `,
    },
    descriptionGridItem: {
        width: 6,
        css: css`
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            max-width: 230px;
                            flex-basis: 230px;
                        `,
                    ],
                    "max",
                );
            }}
        `,
    },
    minusIconClickable: {
        css: css`
            display: flex;
            justify-content: center;
            justify-items: center;
            height: 100%;
            margin-left: 6px;
        `,
    },
    noteGridItem: {
        width: 12,
        css: css`
            display: flex;
            flex-direction: column;
        `,
    },
    notesStyledWrapper: {
        css: css`
            width: 100%;

            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            padding: 0;
                        `,
                    ],
                    "max",
                );
            }}
            ${FormFieldStyle} {
                max-width: 574px;
                margin: auto;
                display: block;

                textarea {
                    height: 131px;
                }
            }
        `,
    },
    actionGridItem: {
        width: 12,
        css: css`
            display: flex;
            justify-content: end;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding: 0px;
                        `,
                    ],
                    "max",
                );
            }}
        `,
    },
    inputTextFiled: {
        cssOverrides: {
            formInputWrapper: css`
                div[class^="DescriptionWrapper"] {
                    font-size: 12px !important;
                    font-weight: 600 !important;
                    div[class^="TypographyStyle"] {
                        font-size: 12px !important;
                        font-weight: 600 !important;
                    }
                }
            `,
        },
    },
    mobileScrollView: {
        css: css`
            width: 93%;
            ${GridWrapper} {
                padding: 0 0 0 10px;
                ${GridItemStyle} {
                    padding: 7px 5px;
                    position: relative;
                }
            }
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            overflow-x: scroll;
                            width: 100%;
                            padding-bottom: 10px;
                            height: auto !important;
                            -webkit-overflow-scrolling: touch;
                            ${GridWrapper} {
                                width: 445px;
                            }
                            &::-webkit-scrollbar {
                                width: 10px;
                            }
                            &::-webkit-scrollbar-thumb {
                                background: gray;
                                border-radius: 5px;
                            }
                            &::-webkit-scrollbar-track {
                                background: #d6d6d6;
                            }
                        `,
                    ],
                    "max",
                );
            }}
        `,
    },
    SubmitButtonWrapper: {
        css: css`
            max-width: 576px;
            width: 574px;
            margin: auto;
            padding: 10px;
            ${GridItemStyle} {
                padding: 10px 0 20px;
            }
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            padding: 0 15px;
                        `,
                    ],
                    "max",
                );
            }}
        `,
    },
    QuoteForm: {
        css: css`
            width: 519px !important;
        `,
    },
    onSubmitError: {
        css: css`
            color: #ac1e2d !important;
            font-weight: 600;
            font-size: 14px;
            width: 350px;
        `,
    },
    errorBox: {
        css: css`
            width: 100%;
        `,
    },
    tooTipParent: {
        css: css`
            position: absolute;
            left: 62%;
            right: auto;
            margin: 0;
            width: 170px;
            padding: 15px 0px;
            top: 70%;
            z-index: 1;
        `,
    },
    tooTipContent: {
        css: css`
            border: 1px solid #bcbcbc;
            width: 100%;
            background-color: #fff;
            color: #000;
            border-radius: 5px;
            padding: 11px 14px 11px 14px;
            font-size: 12px !important;
            line-height: 16px;

            &::before {
                content: '' ;
                position: absolute;
                display: inline-block;
                left: 83px;
                top: 3px;
                border-right: 6px solid transparent;
                border-bottom: 6px solid #555;
                border-left: 6px solid transparent;
            }
            &::after {
                content: '';
                position: absolute;
                bottom: 100%;
                left: 84px;
                top: 4px;
                border-right: 5px solid transparent;
                border-bottom: 5px solid #fff;
                border-left: 5px solid transparent;
            }
        `,
    },
};

const styles = adiMyAccountStyles;

interface QuoteProducts {
    quantity: string;
    adiNumber: string;
    details: string;
}

interface EnteredProductListProps {
    quoteProducts: QuoteProducts[] | undefined;
    setQuoteProducts: Function;
    formQuoteProductsError: any;
    isShowProductErrorText: boolean;
    isUnknown: any;
    isProductsEmpty: boolean;
    isSubmitButtonClicked: boolean;
    setFormQuoteProductsError: React.Dispatch<React.SetStateAction<any>>;
    setIsProductsEmpty: React.Dispatch<React.SetStateAction<any>>
}
export interface productVisibilityItem {
    company: string;
    customer: string;
    item: string;
    restricted: string;
    visible: string;
    productDescription: string;
}

const textBoxStyle = (isYellow: boolean, isProductsEmpty: boolean, index: number) => {
    return {
        backgroundColor: isYellow ? "#f8c41133" : "white",
        color: "black",
        border: isProductsEmpty && index < 6 ? "1px solid red" : undefined,
    };
};


const EnteredProductList: FC<EnteredProductListProps> = ({
    quoteProducts,
    setQuoteProducts,
    formQuoteProductsError,
    isShowProductErrorText,
    isUnknown,
    isProductsEmpty,
    isSubmitButtonClicked,
    setFormQuoteProductsError,
    setIsProductsEmpty,
}) => {
    if (!quoteProducts) {
        return null;
    }

    // const {result}=isUnknown;
    const onRemoveQuoteProduct = (index: number) => {
        setQuoteProducts((prev: QuoteProducts[]) => {
            let newQuoteproduct = [...prev];
            newQuoteproduct.splice(index, 1);
            return newQuoteproduct;
        });
    };
    const onChangeInput = (e: ChangeEvent<HTMLInputElement>) => {
        setIsProductsEmpty(false)
        const splitedName = e.target.name.split("-");
        const value = e.target.value;
        const name = splitedName[0];
        const index = parseInt(splitedName[1]);

        if (name === "quantity") {
            if (!/^\d*$/.test(e.target.value)) {
                return;
            }

            const errorsCopy = { ...(formQuoteProductsError || {}) };
            if (!errorsCopy[index]) errorsCopy[index] = {};

            if (value.trim() === "") {
                delete errorsCopy[index].quantity;
            } else if (Number(value.trim()) === 0) {
                errorsCopy[index].quantity = translate("Please enter number only");
            } else {
                delete errorsCopy[index].quantity;
            }

            if (Object.keys(errorsCopy[index]).length === 0) {
                delete errorsCopy[index];
            }

            setFormQuoteProductsError(errorsCopy);
        }

        if (name) {
            setQuoteProducts((prev: QuoteProducts[]) => {
                let newQuoteproduct = [...prev];
                const seleletedProduct = newQuoteproduct[index];
                const exctratedProduct = {
                    quantity: seleletedProduct.quantity,
                    adiNumber: seleletedProduct.adiNumber,
                    details: seleletedProduct.details,
                };
                newQuoteproduct[index] = { ...exctratedProduct, [name]: value };

                return newQuoteproduct;
            });
        }
        // setQuoteProducts(quoteProducts)
        // setquoteProductdata(quoteProducts)
        // setQuoteProducts(quoteProducts)
    };
    const addNewRow = () => {
        let count = 5;
        const newQuoteProducts = [...quoteProducts];
        for (let i = 0; i < count; i++) {
            const product = { quantity: "", adiNumber: "", details: "" };

            newQuoteProducts.push(product);
        }
        setQuoteProducts([...newQuoteProducts]);
    };

    const [adiNumber, setAdiNumber] = useState<boolean | string>("");
    const [quantity, setQuantity] = useState<boolean | string>("");
    const [initiaColor, setInitialColor] = useState(true);
    const [tooltipVisible, setTooltipVisible] = useState<number | null>(null);

    const openTooltip = (index: number) => {
        setTooltipVisible(index);
    };
    const closeTooltip = () => {
        setTooltipVisible(null)
    };

    useEffect(() => {
        setAdiNumber(isShowProductErrorText ? translate("Please enter a part number") : isShowProductErrorText);
        setQuantity(isShowProductErrorText ? translate("Please enter a quantity") : isShowProductErrorText);
    }, [isShowProductErrorText]);

    return (
        <>
            <GridContainer {...styles.productListHeaderGridContainer}>
                <GridItem {...styles.quantityGridItem}>
                    <Typography {...styles.enterProductListText}>{translate("Quantity")}</Typography>
                </GridItem>
                <GridItem {...styles.modelGridItem}>
                    <Typography {...styles.enterProductListText}>{translate("ADI/Model #")}</Typography>
                </GridItem>
                <GridItem {...styles.descriptionGridItem}>
                    <Typography {...styles.enterProductListText}>{translate("Description/Manufacturer")}</Typography>
                </GridItem>
            </GridContainer>
            {quoteProducts &&
                quoteProducts?.map((item, index) => {
                    const isYellow = isUnknown?.find(
                        (Unknown: any) =>
                            item?.adiNumber === Unknown?.item && Unknown?.productDescription === "RequestForQuote",
                    );

                    const quantityError = formQuoteProductsError && formQuoteProductsError[index] && formQuoteProductsError[index].quantity;
                    const adiNumberError = formQuoteProductsError && formQuoteProductsError[index] && formQuoteProductsError[index].adiNumber;
                    const detailsError = formQuoteProductsError && formQuoteProductsError[index] && formQuoteProductsError[index].details;

                    return (
                        <GridContainer key={index} {...styles.productListTextFieldsGridContainer}>
                            <GridItem {...styles.quantityGridItem}>
                                <TextField
                                    sizeVariant="small"
                                    value={item.quantity}
                                    name={`quantity-${index}`}
                                    maxLength={4}
                                    error={Boolean(quantityError) ? quantityError : ""}
                                    onChange={onChangeInput}
                                    style={textBoxStyle(isYellow, isProductsEmpty, index)}
                                />
                            </GridItem>
                            <GridItem {...styles.modelGridItem}>
                                <TextField
                                    sizeVariant="small"
                                    value={item.adiNumber}
                                    name={`adiNumber-${index}`}
                                    maxLength={25}
                                    error={Boolean(adiNumberError) ? adiNumberError : ""}
                                    onChange={onChangeInput}
                                    style={textBoxStyle(isYellow, isProductsEmpty, index)}
                                />
                            </GridItem>
                            <GridItem {...styles.descriptionGridItem}>
                                <TextField
                                    sizeVariant="small"
                                    value={item.details}
                                    name={`details-${index}`}
                                    maxLength={107}
                                    error={Boolean(detailsError) ? detailsError : ""}
                                    onChange={onChangeInput}
                                    style={textBoxStyle(isYellow, isProductsEmpty, index)}
                                />
                                {quoteProducts.length > 1 && (
                                    <Clickable
                                        {...styles.minusIconClickable}
                                        type="button"
                                        onClick={() => onRemoveQuoteProduct(index)}
                                        onMouseEnter={() => openTooltip(index)}
                                        onMouseLeave={closeTooltip}
                                    >
                                        <Icon
                                            src={XCircle}
                                            color="gray"
                                            css={css`
                                                width: 10px;
                                            `}
                                        />
                                    </Clickable>
                                )}

                                {tooltipVisible === index &&
                                    <StyledWrapper {...styles.tooTipParent}>
                                        <Typography {...styles.tooTipContent}> {translate("Click here to remove row")} </Typography>
                                    </StyledWrapper>
                                }

                            </GridItem>
                        </GridContainer>
                    );
                })
            }
            <StyledWrapper {...styles.addMoreLinkStyledWrapper}>
                <Link as="a" {...styles.addMoreLink} onClick={addNewRow}>
                    <Icon src={Plus} size={14} /> {translate("Add More")}
                </Link>
            </StyledWrapper>
        </>
    );
};

const intialErrorState = {
    contactName: "",
    email: "",
    phoneNumber: "",
    projectName: "",
    notes: "",
    filesAndProduct: "",
};

const FILE_EXTENTIONS = "csv";

const RequestQuoteForm: FC<Props> = ({
    adminDCEmail,
    loadCurrentAccount,
    session,
    account,
    cart,
    getSubmitRequestQuotenHandler,
    search,
    loadWishLists,
    loadWishListLineV2,
    loadWishList,
    isAuthenticated,
    pathname,
    history,
    billToParentState,
    billToId,
    billtoChildren,
    billToState,
}) => {
    const [isProductsEmpty, setIsProductsEmpty] = useState<boolean>(false);
    const [quoteProducts, setQuoteProducts] = useState<QuoteProducts[]>();
    const [quoteProductdata, setquoteProductdata] = useState<any>([]);
    const [contactName, setContactName] = useState(`${session.firstName} ${session.lastName}`);
    const [email, setEmail] = useState(session.email);
    const [phoneNumber, setPhoneNumber] = useState("");
    const [projectName, setProjectName] = useState("");
    const [notes, setNotes] = useState("");
    const [dcEmail, setDcEmail] = useState(adminDCEmail);
    const [files, setFiles] = useState<any[]>([]);
    const [dropzone, setDropzone] = useState<any>();
    const [uploadBorder, setuploadBorder] = useState<any>(false);
    const [formErrors, setFormErrors] = useState(intialErrorState);
    const [formQuoteProductsError, setFormQuoteProductsError] = useState<any>();
    const [isShowProductErrorText, setIsShowProductErrorText] = useState(false);
    const [invalidMessage, setInvalidMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [selectedBillTo, setSelectedBillTo] = useState("");
    const [billTo, setBillTo] = useState<BillToModel>();
    const shipToDisplay = billtoChildren?.map(billTo => billTo.shipTos).map((shipto: any) => shipto[0]);
    const billToIds = billtoChildren?.map(billto => billto.id);
    const [suffix, setSuffix] = useState("");
    const [selectedCustomerNumberQuote, setSelectedCustomerNumberQuote] = useState("");
    const [isOpenUploadModal, setIsOpenUploadModal] = useState(false);
    // process data
    const [unknownProducts, setunknownProducts] = useState<productVisibilityItem[]>();
    const [RQFProductVisibility_Response, setRQFProductVisibility_Response] = useState<productVisibilityItem[]>();
    const [submitErrors, setsubmitErrors] = useState<boolean>(false);
    const [quoteNumbers, setquoteNumbers] = useState<any>();
    const [cleanQuote, setcleanQuote] = useState<any>();
    const [submits, setsubmits] = useState<boolean>(false);
    const [requestQuoteSubmit, setRequestQuoteSubmit] = useState<boolean>(false);
    const [isrequestSubmitting, setIsrequestSubmitting] = useState<boolean>(false);
    const [isSubmitButtonClicked, setIsSubmitButtonClicked] = useState<boolean>(false);

    useEffect(() => {
        const product = { quantity: "", adiNumber: "", details: "" };
        const quoteProduct = Array.from(Array(6).keys()).map(item => product);
        setQuoteProducts(quoteProduct);
        loadCurrentAccount();
        // setDropzone(document.getElementById("dropzone"));
    }, []);
    const getDragZone = (element: any) => {
        setDropzone(element);
    };
    const uploadBorderfun = (element: any) => {
        setuploadBorder(element);
    };
    useEffect(() => {
        if (search) {
            const query = parseQueryString<{ quoteRequestFrom: string; wishListName?: string }>(
                search.replace("?", ""),
            );
            if (query && query.quoteRequestFrom === "wishlist" && query.wishListName) {
                getWishLineList(query.wishListName);
            }
        }
    }, [search]);

    useEffect(() => {
        if (search && cart) {
            const query = parseQueryString<{ quoteRequestFrom: string; wishListName?: string }>(
                search.replace("?", ""),
            );
            if (query && query.quoteRequestFrom === "cartList") {
                getCartLineList();
            }
        }
    }, [cart, search]);

    useEffect(() => {
        if (account?.properties) {
            setPhoneNumber(account.properties.phone);
        }
    }, [account]);
    useEffect(() => {
        if (requestQuoteSubmit) {
            SubmitRequestQuote();
            setRequestQuoteSubmit(false);
        }
    }, [requestQuoteSubmit]);
    interface Product {
        quantity: string;
        adiNumber: string;
        details: string;
        properties: {
            isValidProduct: string;
            productType: string;
        };
    }

    const SubmitRequestQuote = async () => {
        const rqfProductVisibilityValidationCompleted: any = quoteProducts
            ?.map((quoteProduct_adiNumber: any) => {
                let rqfProductVisibilityValidation = RQFProductVisibility_Response?.find(
                    (RQFProductVisibility_Response_item: any) =>
                        quoteProduct_adiNumber.adiNumber === RQFProductVisibility_Response_item.item &&
                        RQFProductVisibility_Response_item.productDescription === "RequestForQuote",
                );

                if (rqfProductVisibilityValidation) {
                    return {
                        ...quoteProduct_adiNumber,
                        properties: {
                            isValidProduct: "false",
                            productType: "RequestForQuote",
                        },
                    };
                }
                return {
                    ...quoteProduct_adiNumber,
                    properties: {
                        isValidProduct: "true",
                        productType: "ValidProduct",
                    },
                };

            })
            .filter((item: Product) => item.adiNumber !== "" && item.quantity !== "");
        getSubmitRequestQuotenHandler({
            contactName,
            email,
            phoneNumber,
            projectName,
            quoteProductsList: rqfProductVisibilityValidationCompleted,
            notes,
            dcEmail,
            companyName: "",
            customerNumber: selectedCustomerNumberQuote,
            salesLocation: (billtoChildren && billtoChildren[0]?.properties?.defaultAdminDC) ?? "",
            sourceLocationID: (shipToDisplay && shipToDisplay[0].properties.prefshiptoloc) ?? "",
            onComplete(onSubmitDataResponse: any) {
                if (
                    onSubmitDataResponse &&
                    onSubmitDataResponse.apiResult &&
                    onSubmitDataResponse.apiResult.result &&
                    onSubmitDataResponse.apiResult.result.quoteNumber
                ) {
                    localStorage.setItem("quoteNumberRFQ", onSubmitDataResponse.apiResult.result.quoteNumber);
                    setIsLoading(false);
                    if (search === "?quoteRequestFrom=cartList") {
                        clearCart({
                            cartId: "current",
                        });
                    }
                    history.push("/MyAccount/requestquoteconfirmation");
                    // window.location.href = "/MyAccount/requestquoteconfirmation";
                    setsubmitErrors(false);
                } else {
                    setsubmitErrors(true);
                }
            },
        });
    };
    const getWishLineList = (listName: string) => {
        loadWishLists({
            onComplete(result) {
                if (result.apiResult && result.apiResult.wishListCollection) {
                    const wishlist = result.apiResult.wishListCollection.find(item => item.name === listName);
                    if (wishlist) {
                        loadWishList({
                            wishListId: wishlist.id,
                            name: wishlist.name,
                            parameter: JSON.stringify(wishlist.pagination) as unknown as any,
                            onSuccess(result: any) {
                                if (result && result?.wishListLines) {
                                    const product = { quantity: "", adiNumber: "", details: "" };
                                    const newQuoteProducts = Array.from(Array(6).keys()).map(item => product);
                                    result?.wishListLines.map((item: WishListLineModel, index: number) => {
                                        newQuoteProducts[index] = {
                                            quantity: `${result.productInfosByWishListLineId[item.id].qtyOrdered}`,
                                            adiNumber: item.erpNumber,
                                            details: item.shortDescription,
                                        };
                                    });

                                    setQuoteProducts([...newQuoteProducts]);
                                }
                            },
                        });
                    }
                }
            },
        });
    };

    const getCartLineList = () => {
        if (cart?.cartLines) {
            const product = { quantity: "", adiNumber: "", details: "" };
            const newQuoteProducts = Array.from(Array(6).keys()).map(item => product);
            cart?.cartLines.map((item, index) => {
                newQuoteProducts[index] = {
                    quantity: `${item.qtyOrdered}`,
                    adiNumber: item.erpNumber,
                    details: item.shortDescription,
                };
            });

            setQuoteProducts([...newQuoteProducts]);
        }
    };

    const onHandleChange = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        switch (event.target.name) {
            case "contactName": {
                setContactName(event.target.value);
                break;
            }
            case "email": {
                setEmail(event.target.value);
                break;
            }
            case "phoneNumber": {
                if (event.target.value.length <= 10) {
                    setPhoneNumber(event.target.value);
                }
                if (event.target.value.length <= 9 || !/^\d*$/.test(phoneNumber)) {
                    setFormErrors(prev => ({
                        ...prev,
                        phoneNumber: translate("Phone number must contain at least 10 digits"),
                    }));
                } else {
                    setFormErrors(prev => ({
                        ...prev,
                        phoneNumber: translate(""),
                    }));
                }
                break;
            }
            case "projectName": {
                if (event.target.value.length <= 15) {
                    setProjectName(event.target.value);
                }
                if (event.target.value.length > 0) {
                    setFormErrors(prev => ({
                        ...prev,
                        projectName: translate(""),
                    }))
                }
                break;
            }
            case "notes": {
                setNotes(event.target.value);
                break;
            }
        }
    };
    const handleDrop = (event: any) => {
        event.preventDefault();
        const { files } = event.dataTransfer;
        if (files.length > 0) {
            const fileToUpload = files[0]; // Only take the first file

            if (validateFile(fileToUpload)) {
                uploadFile(fileToUpload);
                setFiles([fileToUpload]); // Set files state to contain only the uploaded file
            }
        }
        dropzone.style.border = "none";
        dropzone.style.backgroundColor = "transparent";

        uploadBorder
            ? (uploadBorder.style.border = `1px dashed ${ADIColors.errorMsgRed}`)
            : `1px dashed ${ADIColors.black}`;
    };

    const handleDragOver = (event: any) => {
        event.preventDefault();
        dropzone.style.border = `2px dashed ${ADIColors.errorMsgRed}`;
        dropzone.style.backgroundColor = `${ADIColors.gray2}`;
    };
    const handleDragLeave = (event: any) => {
        event.preventDefault();
        dropzone.style.border = "none";
        dropzone.style.backgroundColor = "transparent";
    };

    const handleDragStart = (event: any) => {
        event.dataTransfer.setData("text/plain", event.target.id);
    };
    const onRemoveFile = (name: string) => {
        const removedFile = files.find(item => item.name === name);
        if (removedFile) {
            const newFiles = files.filter(item => item.name !== name);
            setFiles([...newFiles]);
            setquoteProductdata([]);
        }
    };

    const validateFile = (file: File) => {
        const fileextensions = FILE_EXTENTIONS.split(",");
        if (file.name !== "" && !files.some(x => x.name === file.name)) {
            const splittedfilename: string[] = file.name.split(".");
            const currentfileextension =
                splittedfilename.length > 0 ? splittedfilename[splittedfilename.length - 1].toLowerCase() : "";
            const invalidfilextension =
                currentfileextension !== fileextensions[fileextensions.indexOf(currentfileextension)];
            if (invalidfilextension) {
                setquoteProductdata([]);
                setInvalidMessage(translate("Invalid file. Please try uploading your file again in CSV format."));
                return false;
            }
            setuploadBorder(false);
            return true;
        }
        return false;

    };
    const onAddFile = (event: ChangeEvent<any>) => {
        if (event.target.files.length > 0) {
            setInvalidMessage("");
            const file = event.target.files[0];
            if (validateFile(file)) {
                const newFile = files.filter(item => item.name === file.name);
                if (newFile.length <= 0) {
                    // setFiles(prev => [...prev, file]); for Adding multiple file
                    setFiles([file]); // for addding latest only single file

                    uploadFile(file);
                }
            }
        }
        // ADINA-49447
        event.target.value = null;
    };

    const uploadFile = (value: any) => {
        let rdr = new FileReader();
        rdr.onloadend = () => {
            let base64data = rdr.result;
            if (base64data) {
                let filedata = base64data.toString().substr(base64data.toString().indexOf(",") + 1);
                let csvContent = atob(filedata);

                let lines = csvContent.split("\r");
                if (lines.slice(1, -1).length > 50) {
                    setquoteProductdata([]);
                    setFiles([]);
                    // setQuoteProducts([])
                    setInvalidMessage(translate("You have reached the maximum limit for Items/Products"));
                    return;
                }
                setInvalidMessage(translate(""));

                if (lines.length === 0 || (lines.length === 2 && (lines[0].trim() === "" || lines[0].trim() === "Item Count,Item Number,Description"))) {
                    setquoteProductdata([]);
                    setFiles([]);

                    setInvalidMessage(
                        translate(
                            "This file is empty. Please try uploading your file again with the Item Count, Item Number, Description data included",
                        ),
                    );
                    return;
                }
                setInvalidMessage(translate(""));

                if (lines.length > 0) {
                    let header = lines[0].split(",");

                    let cleaned_data = header.map(item => item.replace("ï»¿", ""));

                    let requiredColumns = ["Item Count", "Item Number", "Description"];
                    let missingColumns = requiredColumns.filter(column => !cleaned_data.includes(column));
                    if (missingColumns.length > 0) {
                        setquoteProductdata([]);
                        setFiles([]);

                        setInvalidMessage(
                            translate(
                                "Invalid file. Please try uploading your file again with the Item Count, Item Number, Description columns included.",
                            ),
                        );

                        return;
                    }

                    let itemCountIndex = cleaned_data.indexOf("Item Count");
                    let itemNumberIndex = cleaned_data.indexOf("Item Number");
                    let descriptionIndex = cleaned_data.indexOf("Description");
                    let csvData = lines.slice(1)
                        .map(line => line.split(","))
                        .filter(row => row.some(cell => cell.trim() !== ""));

                    const invalidRows = csvData.filter(row => row[itemNumberIndex]?.trim() === "" || row[itemNumberIndex] === undefined);

                    if (invalidRows.length > 0) {
                        setquoteProductdata([]);
                        setFiles([]);
                        setInvalidMessage(translate("Invalid file. There is no Item Number available."));
                        return;
                    }
                    if (hasInvalidItemCounts(csvData, itemCountIndex, itemNumberIndex, descriptionIndex)) {
                        setquoteProductdata([]);
                        setFiles([]);
                        setInvalidMessage(translate("Invalid File. File contains items with Zero or Empty Quantity"));
                        return;
                    }
                } else {
                    setFiles([]);

                    setInvalidMessage(translate("Invalid file. your file is empty"));
                    return;
                }
                const csvData = lines
                    .slice(1)
                    .map(line => line.trim())
                    .filter(line => line !== "");

                setQuoteProducts((prev: any) => {
                    if (Array.isArray(prev)) {
                        return [...prev, ...csvData];
                    }
                    return csvData;

                });
            }
        };
        rdr.readAsDataURL(value);
    };

    const hasInvalidItemCounts = (
        csvData: string[][],
        itemCountIndex: number,
        itemNumberIndex: number,
        descriptionIndex: number
    ): boolean => {
        if (!csvData || csvData.length === 0) {
            return false;
        }
        return csvData.some(row => {
            const itemCount = parseFloat(row[itemCountIndex]);
            const itemNumber = row[itemNumberIndex];
            const description = row[descriptionIndex];
            const hasData = itemNumber !== "" || description !== "";
            return hasData && (isNaN(itemCount) || itemCount <= 0);
        });
    };

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = event.currentTarget;
        setContactName(value);
        if (!/^[a-zA-Z]([a-zA-Z\s]*[a-zA-Z])?$/.test(value) && value !== "") {
            setFormErrors(prev => ({
                ...prev,
                contactName: translate("Alphabet, Numbers, Space, Comma, ., *, -, \\, #, and / are only allowed"),
            }));
        } else if (value.trim() === "") {
            setFormErrors(prev => ({
                ...prev,
                contactName: translate("Contact Name is a required field."),
            }));
        } else {
            setFormErrors(prev => ({
                ...prev,
                isValid: true,
                contactName: "",
            }));
        }
    };



    const isValidateRequest = () => {
        let isValid = true;
        setIsShowProductErrorText(false);
        setFormQuoteProductsError(undefined);
        if (contactName === "") {
            setFormErrors(prev => ({ ...prev, contactName: translate("Contact Name is a required field.") }));
            isValid = false;
        } else if (!/^[a-zA-Z]([a-zA-Z\s]*[a-zA-Z])?$/.test(contactName) && contactName !== "") {
            setFormErrors(prev => ({
                ...prev,
                contactName: translate("Alphabet, Numbers, Space, Comma, ., *, -, \\, #, and / are only allowed"),
            }));
            isValid = false;
        }
        const validateEmail = (email: string): boolean => {
            const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            return emailPattern.test(email);
        };
        if (email === "") {
            setFormErrors(prev => ({ ...prev, email: translate("Email is a required field.") }));
            isValid = false;
        } else {
            const emailValid = validateEmail(email);
            setFormErrors(prev => ({ ...prev, email: !emailValid ? translate("Please enter a valid email address.") : "" }));
            isValid = isValid && emailValid;
        }

        if (phoneNumber === "") {
            setFormErrors(prev => ({ ...prev, phoneNumber: translate("Phone Number is a required field.") }));
            isValid = false;
        } else if (phoneNumber.length <= 9 || !/^\d*$/.test(phoneNumber)) {
            setFormErrors(prev => ({
                ...prev,
                phoneNumber: translate("Phone number must contain at least 10 digits"),
            }));
            isValid = false;
        }

        if (projectName === "") {
            setFormErrors(prev => ({ ...prev, projectName: translate("Job/Project Name is a required field.") }));
            isValid = false;
        }

        const productErrorQuote: Record<number, any> = {};
        if (quoteProducts) {
            quoteProducts.forEach((item, index) => {
                const rowErrors: Record<string, string> = {};

                const adiNumber = (item.adiNumber || "").toString().trim();
                const quantity = (item.quantity != null ? item.quantity : "").toString().trim();
                const details = (item.details || "").toString().trim();

                const hasAnyFieldFilled = adiNumber !== "" || quantity !== "" || details !== "";
                if (hasAnyFieldFilled) {
                    if (adiNumber === "") {
                        rowErrors.adiNumber = translate("Please enter a part number");
                        isValid = false;
                    }
                    if (quantity === "") {
                        rowErrors.quantity = translate("Please enter a quantity");
                        isValid = false;
                    } else if (Number(quantity) === 0) {
                        rowErrors.quantity = translate("Please enter number only");
                        isValid = false;
                    }
                }

                const allFieldsAreEmpty = quoteProducts?.every(
                    (item) => item.adiNumber === "" && item.quantity === "" && item.details === ""
                );

                if (Object.keys(rowErrors).length > 0 && !allFieldsAreEmpty) {
                    productErrorQuote[index] = rowErrors;
                }
            });

            const allFieldsEmpty = quoteProducts?.every(
                (item) => item.adiNumber === "" && item.quantity === "" && item.details === ""
            );
            setIsProductsEmpty(allFieldsEmpty);
        }

        if (Object.keys(productErrorQuote).length > 0) {
            setFormQuoteProductsError(productErrorQuote);
        }

        const quoteProductIsEmpty = quoteProducts?.filter(item => item.quantity !== "" && item.adiNumber !== "");

        if (files.length === 0 && quoteProducts && quoteProductIsEmpty && quoteProductIsEmpty.length === 0) {
            setIsShowProductErrorText(true);
            setFormErrors(prev => ({
                ...prev,
                filesAndProduct: translate("Please upload a competitor's quote or add a product list to continue."),
            }));
            isValid = false;
        }

        return isValid;
    };

    interface ProductInfo {
        quantity?: number | any;
        adiNumber: string;
        details: string;
    }

    function parseProductInfo(infoStr: string): ProductInfo | null {
        const pattern = /^\s*(\d+)?,\s*([^,]*?)(?:,(.*))?$/;
        const match = infoStr.match(pattern);
        if (match) {
            const quantity = match[1] ? parseInt(match[1], 10) : "";
            const adiNumber = match[2];
            const details = match[3];

            return { quantity, adiNumber, details };
        }
        return null;

    }

    const parseFunction = (data: any) => {
        return data.map((item: any) => {
            const parsedInfo = parseProductInfo(item);

            if (parsedInfo) {
                return {
                    quantity: parsedInfo.quantity,
                    adiNumber: parsedInfo.adiNumber,
                    details: parsedInfo.details,
                };
            }
        });
    };

    async function RQFProductVisibilityApi(quoteData: QuoteProducts[]) {
        try {
            const adiNumbers: any = quoteData?.map((data: any) => data.adiNumber);

            const RQFProductVisibilityResponse = await RQFProductVisibility({
                companyName: "",
                customerNumber: selectedCustomerNumberQuote,
                productList: adiNumbers,
            });
            const { result, successful } = RQFProductVisibilityResponse;
            const { productVisibilityList } = result;
            productVisibilityList.length <= 0 ? setIsLoading(true) : setIsLoading(false);
            setRQFProductVisibility_Response([...productVisibilityList]);
            setunknownProducts([...productVisibilityList])
        } catch (err) { /* empty */ }
    }
    const setFormQuotedata = async () => {
        function objectToString(obj: { quantity: any; adiNumber: any; details: any }) {
            return `${obj.quantity || ""},${obj.adiNumber || ""},${obj.details || ""}`;
        }
        const objectStrings: any = quoteProducts
            ?.filter(item => typeof item === "object" && Object.values(item).some(val => val !== ""))
            .map(objectToString);

        const remainingStrings: any = quoteProducts?.filter(item => typeof item === "string");
        const result = [...objectStrings, ...remainingStrings];
        const quoteData = parseFunction(result);
        const quotes = [...quoteData];
        setcleanQuote(quotes);
        setQuoteProducts([...quoteData]);
        setsubmits(prev => !prev);
        await RQFProductVisibilityApi(quoteData);
    };
    const onSubmitQuote = async (e: React.FormEvent<HTMLFormElement>) => {
        setIsSubmitButtonClicked(true);
        setFormErrors(intialErrorState);
        e.preventDefault();
        if (isValidateRequest()) {
            setIsrequestSubmitting(true);
            await setFormQuotedata();
            setRequestQuoteSubmit(true);
        }
    };
    const [shipTosParameter, setShipTosParameter] = React.useState<GetShipTosApiParameter>({
        billToId,
        page: 1,
        pageSize: 20,
        expand: ["validation", "excludeShowAll", "excludeOneTime", "excludeCreateNew"],
    });

    const dispatch: any = useDispatch();
    useEffect(() => {
        if (isAuthenticated) {
            history.push(`${pathname}${search}`);
        } else if (!isAuthenticated) {
            window.location.href = `/MyAccount/SignIn?returnUrl=${pathname}${search}`;
        }
    }, []);

    useEffect(() => {
        if (billToState && billToState.id && suffix === "") {
            setSuffix(billToState.id);
        }
    }, [billToState]);

    useEffect(() => {
        dispatch(
            loadBillToCustom({
                expand: "state,validation,account",
                filter: "",
                page: "",
                pageSize: "",
                getBillingChild: false,
            }),
        );
    }, []);

    useEffect(() => {
        if (billTo) {
            dispatch(
                loadBillToCustom({
                    expand: `state,validation,parent=${billTo.id}`,
                    filter: "",
                    page: "",
                    pageSize: "",
                    getBillingChild: true,
                }),
            );
        }
    }, [billTo]);

    const formatAccountSuffixLabel = (accountSuffixLabel: string) => {
        const formattedLabel = accountSuffixLabel?.split("-")?.[1]?.trim() || "";
        return formattedLabel;
    };
    const accountSuffixDropdown = billtoChildren && billtoChildren.map(item => ({ id: item.id, label: item.label }));
    useEffect(() => {
        if (billToState && billToState.customerNumber && suffix === "") {
            setSelectedCustomerNumberQuote(billToState.customerNumber);
        }
    }, [billToState]);

    useEffect(() => {
        if (billtoChildren && billtoChildren.length > 0) {
            setSuffix(billtoChildren[0].id);
            setSelectedCustomerNumberQuote(billtoChildren[0].customerNumber);
        }
    }, [billtoChildren]);
    

    const handleSuffixChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        if (event.target.value) {
            setSuffix(event.target.value);
            const billTo = billtoChildren?.filter(billTo => billTo.id === event.target.value);
            if (billTo && billTo.length) {
                setSelectedCustomerNumberQuote(billTo[0].customerNumber);
            }
        }
    };

    useEffect(() => {
        const billTo = billToParentState?.billTos.filter(
            (billTo: any) => billTo.customerNumber === billToParentState.properties.currentCustomerNumber,
        );

        if (billTo && billTo.length) {
            setSelectedBillTo(billTo[0].id);
            billToSelectedHandler(billTo[0] as unknown as BillToModel);
        }
    }, [billToParentState?.billTos]);

    const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        if (event.target.value) {
            const billTo = billToParentState?.billTos.filter(billTo => billTo.id === event.target.value);
            if (billTo && billTo.length) {
                billToSelectedHandler(billTo[0] as unknown as BillToModel);
                setSelectedBillTo(billTo[0].id);
            }
        }
    };

    const billToSelectedHandler = (billTo: BillToModel) => {
        setBillTo(billTo);
        setShipTosParameter({
            ...shipTosParameter,
            billToId: billTo.id,
        });
    };

    // This function is to find whether P21 contact is id mapped or not, and also to check with its suffix.
    const isP21ContactIDMapped = billtoChildren?.find(billTo => {
        if (
            billTo.properties.p21ContactID !== "0" &&
            billTo.properties.p21ContactID !== "" &&
            billTo.properties.p21ContactID !== null
        ) {
            return true;
        }
    });

    return (
        <form onSubmit={onSubmitQuote}>
            <LoadingOverlay {...styles.loadingOverlay} loading={isLoading}>
                {isLoading && <LoadingSpinner {...styles.spinner} />}

                <Typography as="div" {...styles.headings}>
                    {translate("Request Quote")}
                </Typography>
                <Typography as="div" {...styles.description}>
                    {translate(
                        "Start a new quote to get project pricing at ADI by entering a product list or uploading a comptetior's code",
                    )}
                </Typography>
                <TextField type="hidden" name="customerAccountno" />
                <TextField type="hidden" name="companyName" />
                <GridContainer {...styles.requestQuoteGridContainer}>
                    <GridItem width={12} {...styles.contactInformationGridItem}>
                        <Typography as="div" {...styles.subHeadings}>
                            {translate("Contact Information")}
                        </Typography>
                        <StyledWrapper {...styles.contactInformationStyledWrapper}>
                            <TextField
                                label="Contact Name *"
                                name="contactName"
                                value={contactName}
                                error={formErrors.contactName}
                                onChange={handleInputChange}
                                {...styles.inputTextFiled}
                            />
                            <TextField
                                label="Email *"
                                name="email"
                                value={email}
                                error={formErrors.email}
                                onChange={onHandleChange}
                            />
                            <TextField
                                label="Phone Number *"
                                name="phoneNumber"
                                value={phoneNumber}
                                error={formErrors.phoneNumber}
                                onChange={onHandleChange}
                            />
                            <TextField
                                label="Job/Project Name *"
                                name="projectName"
                                value={projectName}
                                error={formErrors.projectName}
                                onChange={onHandleChange}
                            />

                            <StyledWrapper {...styles.container}>
                                <Typography {...styles.title}>{translate("Select Account Number ")}</Typography>
                                <Select
                                    onChange={handleSelectChange}
                                    value={selectedBillTo}
                                    disabled={billToParentState?.billTos.length === 1}
                                    {...styles.selectStyles}
                                >
                                    {billToParentState?.billTos.map(accountNumber => (
                                        <option value={accountNumber.id}>{accountNumber.label}</option>
                                    ))}
                                </Select>
                            </StyledWrapper>

                            <StyledWrapper {...styles.container}>
                                <Typography {...styles.title}>{translate("Select Account Suffix ")}</Typography>
                                <Select
                                    value={suffix}
                                    disabled={billtoChildren?.length === 1}
                                    onChange={handleSuffixChange}
                                >
                                    {shipToDisplay?.length && billToIds?.length && billtoChildren?.length
                                        ? accountSuffixDropdown &&
                                        accountSuffixDropdown.map((accountSuffixList, index: number) => {
                                            return (
                                                <option value={accountSuffixList?.id}>
                                                    {formatAccountSuffixLabel(accountSuffixList.label)}
                                                </option>
                                            );
                                        })
                                        : null}
                                </Select>
                            </StyledWrapper>
                        </StyledWrapper>
                    </GridItem>
                    <GridItem width={12} {...styles.enterProductListGridItem}>
                        <Typography as="div" {...styles.subHeadings}>
                            {translate("Products List")}
                        </Typography>
                        <Typography as="ul" {...styles.ProductListUL}>
                            <Typography as="li" {...styles.subDescription}>
                                {translate(
                                    "You can manually enter the ADI model numbers, descriptions and/or manufacturers, and quantities below.",
                                )}
                            </Typography>
                            <Typography as="h6" {...styles.subDescriptionOR}>
                                {translate("-OR-")}
                            </Typography>
                            <Typography as="li" {...styles.subDescription}>
                                <Typography
                                    as="a"
                                    color="#006ae3"
                                    onClick={() => setIsOpenUploadModal(true)}
                                    {...styles.upload}
                                >
                                    {translate("Upload ")}
                                </Typography>
                                <Typography>
                                    {translate(
                                        "a list of products. You'll be able to review your entries prior to quote submission.",
                                    )}
                                </Typography>
                            </Typography>

                            {submits ? (
                                <Typography as="li" {...styles.uploadMessage}>
                                    {translate(
                                        "Highlighted items do not directly match any part in our system and will be reviewed by an ADI Representative. You can continue with the submission.",
                                    )}
                                </Typography>
                            ) : (
                                ""
                            )}
                        </Typography>
                        <ADIRequestQuoteUploadModal
                            isOpen={isOpenUploadModal}
                            closeQuoteModal={() => {
                                setIsOpenUploadModal(false);
                                setFiles([]);
                                setInvalidMessage("");
                            }}
                            invalidMessage={invalidMessage}
                            formErrors={formErrors}
                            handleDrop={handleDrop}
                            handleDragOver={handleDragOver}
                            handleDragLeave={handleDragLeave}
                            handleDragStart={handleDragStart}
                            onAddFile={onAddFile}
                            files={files}
                            onRemoveFile={onRemoveFile}
                            setDropzone={getDragZone}
                            setuploadBorder={uploadBorderfun}
                            setFormQuotedata={setFormQuotedata}
                        />
                        <StyledWrapper {...styles.mobileScrollView}>
                            <EnteredProductList
                                quoteProducts={quoteProducts}
                                setQuoteProducts={setQuoteProducts}
                                formQuoteProductsError={formQuoteProductsError}
                                isShowProductErrorText={isShowProductErrorText}
                                isUnknown={unknownProducts}
                                isProductsEmpty={isProductsEmpty}
                                isSubmitButtonClicked={isSubmitButtonClicked}
                                setFormQuoteProductsError={setFormQuoteProductsError}
                                setIsProductsEmpty={setIsProductsEmpty}
                            />
                        </StyledWrapper>
                    </GridItem>
                    <GridItem width={12} {...styles.noteGridItem}>
                        <Typography as="div" {...styles.subHeadings}>
                            {translate("Notes")}
                        </Typography>
                        <Typography as="div" {...styles.subDescription}>
                            {translate("Please provide any additional information that will help us create a quote.")}
                        </Typography>
                        <StyledWrapper {...styles.notesStyledWrapper}>
                            <TextArea name="notes" value={notes} onChange={onHandleChange} />
                        </StyledWrapper>
                    </GridItem>
                    <StyledWrapper {...styles.SubmitButtonWrapper}>
                        <GridItem width={12} {...styles.actionGridItem}>
                            <Typography as="div" {...styles.errorBox}>
                                {submitErrors && (
                                    <Typography as="div" {...styles.onSubmitError}>
                                        {translate(
                                            "There was an error with submitting your quote. Please check that all required fields were filled out. If the problem persists, please contact the Website Support 1.877.228.6739 for further assistance.",
                                        )}
                                    </Typography>
                                )}
                            </Typography>
                            <Button
                                type="submit"
                                variant="primary"
                                disabled={isrequestSubmitting || isP21ContactIDMapped === undefined}
                            >
                                {translate("Submit")}
                            </Button>
                        </GridItem>
                    </StyledWrapper>
                </GridContainer>
            </LoadingOverlay>
        </form>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHistory(RequestQuoteForm)),
    definition: {
        group: "My Account",
        displayName: "ADI Request Quote Form",
    },
};
export default widgetModule;
